import React, { useState, useEffect, useMemo } from 'react';
import BarcodeScanner from './Components/Barcode.js';
import InfoModal from './Components/InfoModal.js';
import './App.css';

const App = () => {
  const [scannedCode, setScannedCode] = useState('');
  const [data, setData] = useState(null);
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [headerContent, setHeaderContent] = useState('');

  const handleScan = (code) => {
    setScannedCode(code);
    fetchData(code); 
  };

  const fetchData = async (code) => {
    getBindings();
    var scriptTag = document.getElementById('rest-api-nonce-js-extra').innerText;
    var nonceValue = null;

    if (scriptTag) {
      var cleanScriptTag = scriptTag.substring(33).slice(0, -12);
      var restNonceObject = JSON.parse(cleanScriptTag);
      var nonceValue = restNonceObject.value;

    } else {
      console.error('Script tag with id "rest-api-nonce-js-extra" not found.');
    }

    const storeId = getCookie("wp-MyStoreID");
    getBindings();

    try {
      getBindings();
      const baseUrl = window.location.origin;
      const response = await fetch(baseUrl + '/wp-json/gfs-search/v1/get-search-results?ps=' + code + '&store=' + storeId, {
        headers: {
          'X-WP-Nonce': nonceValue,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      getBindings();
      const result = await response.json();

      if (result.results.search_results.length > 0) {
        getBindings();
        setData(result.results.search_results);
        setContent(result.content);
        setError();

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "strich_scan_attempt_success"
        });

      } else {
        setError("Not Found");
      }

    } catch (error) {
      setError(error.message);
    }
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const displayProductBox = () => {
    if (scannedCode && content) {
      return (<div id="product-search-results-products" className="products" dangerouslySetInnerHTML={{ __html: content }} />);
    }
  };

  const getBindings = () => {
    if (window.GfsCartBindings && window.GfsCartBindings.bindQtyWidgetActions) {
      window.GfsCartBindings.bindQtyWidgetActions();
    } else {
      console.error('GfsCartBindings or bindQtyWidgetActions is not defined.');
    }

  };

  const closeWarning = () => {
    setError("");
  };

  const displayWarning = () => {
    if (error) {
      return (
        <>
          <div className="warning-label">
            <button onClick={closeWarning}><i class="fa-solid fa-xmark"></i></button>
            <p className="warning-label-title">Barcode Not Found</p>
            <p className="warning-label-text">A code was detected, but it doesn't match any products available at your store.</p>
          </div>
        </>
      )
    }
  };

  const sendFeedbackValue = (value) => {
    const resultArray = [];

    for (let i = value; i >= 1; i--) {
      resultArray.push("star" + i);
    };

    resultArray.forEach(element => {
      const mySelectElement = document.getElementById(element);
      const mySelectIcon = mySelectElement.querySelector('.fa-light');
      mySelectIcon.style.fontWeight = '600';
    });

    const blankResult = [];
    for (let i = 5; i > value; i--) {
      blankResult.push("star" + i);
    };

    blankResult.forEach(element => {
      const mySelectElement = document.getElementById(element);
      const mySelectIcon = mySelectElement.querySelector('i');
      mySelectIcon.style.fontWeight = '100';
    });

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "strich_feedback_submitted",
      rating: value
    });

  };

  const submitForm = () => {
    const newContent = (
      <p className="feedback-success-msg">Thank you for your feedback!</p>
    )
    setModalContent(newContent);
  }

  const feedbackModalContent = (
    <div className="feedback-modal-container">
      <div className="feedback-modal-content">
        <strong>How was your scanning experience?</strong>
        <p className="feedback-rating-text">Rate your experience:</p>
        <p className="feedback-stars-container">
          <button className="feedback-star" id="star1" onClick={() => sendFeedbackValue(1)}><i class="fa-light fa-star"></i></button>
          <button className="feedback-star" id="star2" onClick={() => sendFeedbackValue(2)}><i class="fa-light fa-star"></i></button>
          <button className="feedback-star" id="star3" onClick={() => sendFeedbackValue(3)}><i class="fa-light fa-star"></i></button>
          <button className="feedback-star" id="star4" onClick={() => sendFeedbackValue(4)}><i class="fa-light fa-star"></i></button>
          <button className="feedback-star" id="star5" onClick={() => sendFeedbackValue(5)}><i class="fa-light fa-star"></i></button>
        </p>
        <div className="feedback-submit-container">
          <button className="feedback-submit-btn" type="button" onClick={submitForm}>Submit Feedback</button>
        </div>
      </div>
    </div>
  );

  const infoModalContent = (
    <ul>
      <li>
        <strong>Hold the Camera Still:</strong>
        <p>Position your phone's camera steadily, ensuring it is parallel to the barcode. Hold it still to allow the app to capture a clear image.</p>
      </li>
      <li>
        <strong>Position the Barcode Clearly:</strong>
        <p>Make sure the barcode is well-centered within the camera frame for accurate scanning.</p>
      </li>
      <li>
        <strong>Manually Type the Barcode:</strong>
        <p>If the scanner still isn't detecting the barcode correctly, you can manually enter the number under the barcode into the search bar.</p>
      </li>
    </ul>
  );

  const displayModalButton = () => {
    return (
      <>
        <button onClick={() => openModal(infoModalContent, "Barcode Scanning Tips")} className="info-modal-open-btn">
          <i class="fa-solid fa-question"></i>
        </button>
      </>
    );

  };

  const openModal = (content, header) => {
    setModalContent(content);
    setHeaderContent(header);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <h1>Barcode Scanner</h1>

      <InfoModal isOpen={isModalOpen} closeModal={closeModal} modalContent={modalContent} headerContent={headerContent} />
      <BarcodeScanner onScan={handleScan} />

      {displayModalButton()}
      {displayWarning()}
      {displayProductBox()}

      <div className="feedback-container">
        <p className="feedback-text">We'd love to hear about your scanning experience! <button className="feedback-btn" onClick={() => openModal(feedbackModalContent, "")}>Give feedback</button></p>
      </div>
    </div>
  );
};

export default App;
